(() => {
  const qs = (selector, root = document) => root.querySelector(selector);
  const qsa = (selector, root = document) => Array.from(root.querySelectorAll(selector));

  if (qs('.shopify-policy__container')) {
    const title = qs('.shopify-policy__title h1, .shopify-policy__title');
    const titleMap = {
      'privacy policy': 'Privacy Policy',
      'terms of service': 'Terms of Service',
      'refund policy': 'Return and Refund Policy',
      'shipping policy': 'Shipping Policy'
    };
    if (title) {
      const normalized = title.textContent.trim().toLowerCase();
      if (titleMap[normalized]) title.textContent = titleMap[normalized];
    }
    const body = qs('.shopify-policy__body');
    const firstParagraph = body?.querySelector('p');
    if (firstParagraph) {
      const match = firstParagraph.textContent.match(/^(Last updated:)(.*)$/i);
      if (match) {
        firstParagraph.replaceChildren();
        const label = document.createElement('strong');
        label.textContent = 'Last updated:';
        firstParagraph.append(label, match[2]);
      }
    }
  }

  document.documentElement.classList.remove('no-js');

  if (document.body.classList.contains('template-product')) {
    document.addEventListener('click', (event) => {
      const badge = event.target.closest('.jdgm-prev-badge');
      if (!badge) return;
      const reviews = qs('.jdgm-rev-widg');
      if (!reviews) return;
      event.preventDefault();
      reviews.id = 'judgeme_product_reviews';
      reviews.scrollIntoView({ behavior: 'smooth', block: 'start' });
      window.history.replaceState(null, '', '#judgeme_product_reviews');
    });
  }

  qsa('[data-pack-options]').forEach((options) => {
    const form = options.closest('form');
    const hiddenVariant = qs('[data-selected-variant]', form);
    const hiddenQuantity = qs('[data-selected-quantity]', form);
    const price = qs('[data-product-price]');
    const addButton = qs('button[name="add"]', form);
    const selectVariant = (option) => {
      if (!option || !hiddenVariant) return;
      hiddenVariant.value = option.dataset.variantId;
      options.querySelectorAll('[data-variant-option]').forEach((item) => item.classList.toggle('is-selected', item === option));
      if (price && option.dataset.variantPrice) {
        price.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: 'USD' }).format(Number(option.dataset.variantPrice) / 100);
      }
      if (addButton) addButton.disabled = option.dataset.variantAvailable !== 'true';
      if (hiddenQuantity) {
        const quantity = qs('[data-pack-quantity]', option);
        hiddenQuantity.value = Math.max(1, Number.parseInt(quantity?.value || '1', 10) || 1);
      }
    };
    options.addEventListener('change', (event) => {
      const option = event.target.closest('[data-variant-option]');
      if (!option) return;
      if (event.target.matches('[data-pack-quantity]')) {
        event.target.value = Math.min(99, Math.max(1, Number.parseInt(event.target.value || '1', 10) || 1));
      }
      selectVariant(option);
    });
    options.addEventListener('click', (event) => {
      const button = event.target.closest('[data-pack-quantity-increase], [data-pack-quantity-decrease]');
      if (!button) return;
      event.preventDefault();
      const option = button.closest('[data-variant-option]');
      const quantity = qs('[data-pack-quantity]', option);
      if (!quantity) return;
      const delta = button.hasAttribute('data-pack-quantity-increase') ? 1 : -1;
      quantity.value = Math.min(99, Math.max(1, (Number.parseInt(quantity.value || '1', 10) || 1) + delta));
      selectVariant(option);
    });
    selectVariant(qs('input:checked', options)?.closest('[data-variant-option]') || qs('[data-variant-option]', options));
  });

  qsa('[data-lazy-background]').forEach((section) => {
    const loadBackground = () => {
      if (section.dataset.backgroundLoaded) return;
      section.style.backgroundImage = `url("${section.dataset.lazyBackground}")`;
      section.dataset.backgroundLoaded = 'true';
    };
    if ('IntersectionObserver' in window) {
      new IntersectionObserver((entries, observer) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        loadBackground();
        observer.disconnect();
      }, { rootMargin: '300px' }).observe(section);
    } else {
      loadBackground();
    }
  });

  const productBenefits = qs('.product-info__benefits');
  const productGallery = qs('.product-gallery');
  const productInfo = qs('.product-info');
  const productBenefitAnchor = productBenefits?.previousElementSibling;
  const syncProductBenefitsPlacement = () => {
    if (!productBenefits || !productGallery || !productInfo) return;
    const desktop = window.matchMedia('(min-width: 1200px)').matches;
    if (desktop && productBenefits.parentElement !== productGallery) {
      productGallery.append(productBenefits);
    } else if (!desktop && productBenefits.parentElement !== productInfo) {
      productInfo.insertBefore(productBenefits, productBenefitAnchor?.nextSibling || productInfo.firstChild);
    }
  };
  if (productBenefits) {
    syncProductBenefitsPlacement();
    window.addEventListener('resize', syncProductBenefitsPlacement, { passive: true });
  }

  qsa('[data-play-video]').forEach((playTarget) => {
    const media = playTarget.closest('.directions-video__media');
    if (!media) return;

    const startVideo = () => {
      let video = media.querySelector('[data-playable-video]');
      if (!video && media.dataset.videoSrc) {
        video = document.createElement('video');
        video.setAttribute('playsinline', '');
        video.setAttribute('controls', '');
        video.setAttribute('preload', 'metadata');
        video.setAttribute('data-playable-video', '');
        if (media.dataset.posterSrc) video.setAttribute('poster', media.dataset.posterSrc);
        const source = document.createElement('source');
        source.src = media.dataset.videoSrc;
        source.type = 'video/mp4';
        video.append(source);
        media.append(video);
      }
      if (!video) return;
      media.classList.add('is-playing');
      const promise = video.play?.();
      promise?.catch?.(() => {});
    };

    playTarget.addEventListener('click', startVideo);
    playTarget.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      startVideo();
    });
  });

  // Keep the bulk/team CTA directly below the product story and above reviews,
  // including when Shopify serves a stale saved section order.
  const teamSupply = qs('.team-supply-section');
  const productStory = qs('.product-visual-story');
  if (teamSupply && productStory) {
    const teamSection = teamSupply.closest('.shopify-section') || teamSupply;
    const storySection = productStory.closest('.shopify-section') || productStory;
    storySection.parentNode?.insertBefore(teamSection, storySection.nextSibling);
  }

  // E-RACER™ must never break across lines: swap its hyphen for a
  // non-breaking hyphen in every text node (covers rich text, reviews, etc).
  const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
  const eracerNodes = [];
  while (walker.nextNode()) {
    if (walker.currentNode.data.includes('E-RACER')) eracerNodes.push(walker.currentNode);
  }
  eracerNodes.forEach((node) => {
    node.data = node.data.replace(/E-RACER/g, 'E‑RACER');
  });

  const header = qs('.header-main');
  if (header) {
    const announcement = qs('.announcement');
    let lastScrollY = window.scrollY;
    let ticking = false;
    const revealOffset = 120;
    const deltaThreshold = 8;

    const syncHeader = () => {
      const currentScrollY = Math.max(window.scrollY, 0);
      const delta = currentScrollY - lastScrollY;
      const announcementOffset = announcement ? Math.max(announcement.offsetHeight - currentScrollY, 0) : 0;
      const headerTop = announcementOffset;
      const headerHeight = header.offsetHeight;
      const nearTop = currentScrollY < revealOffset;
      const scrollingDown = delta > deltaThreshold;
      const scrollingUp = delta < -deltaThreshold;

      document.documentElement.style.setProperty('--header-float-top', `${headerTop}px`);
      document.documentElement.style.setProperty('--mobile-drawer-top', `${headerTop + headerHeight}px`);
      document.body.classList.toggle('header-floating', !nearTop);

      if (nearTop || document.body.classList.contains('menu-open')) {
        document.body.classList.remove('header-hidden');
      } else if (scrollingDown) {
        document.body.classList.add('header-hidden');
      } else if (scrollingUp) {
        document.body.classList.remove('header-hidden');
      }

      lastScrollY = currentScrollY;
      ticking = false;
    };

    window.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(syncHeader);
    }, { passive: true });
    window.addEventListener('resize', syncHeader);

    syncHeader();
  }

  let activeMenuToggle = null;
  const setDrawerState = (open, toggle = qs('[data-menu-toggle]')) => {
    const drawer = qs('#MobileMenu');
    if (!drawer) return;

    toggle?.setAttribute('aria-expanded', String(open));
    drawer.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', String(!open));
    document.body.classList.toggle('menu-open', open);

    if (open) {
      activeMenuToggle = toggle;
      window.setTimeout(() => qs('a, button', drawer)?.focus({ preventScroll: true }), 0);
      return;
    }

    if (drawer.contains(document.activeElement)) {
      activeMenuToggle?.focus({ preventScroll: true });
    }
    activeMenuToggle = null;
  };

  qsa('[data-menu-toggle]').forEach((button) => {
    button.addEventListener('click', () => {
      setDrawerState(button.getAttribute('aria-expanded') !== 'true', button);
    });
  });

  qsa('[data-drawer-close]').forEach((button) => {
    button.addEventListener('click', () => {
      setDrawerState(false);
    });
  });

  qsa('#MobileMenu a').forEach((link) => {
    link.addEventListener('click', () => setDrawerState(false));
  });

  const desktopMenuQuery = window.matchMedia('(min-width: 1301px)');
  const closeDrawerOnDesktop = () => {
    if (desktopMenuQuery.matches && document.body.classList.contains('menu-open')) {
      setDrawerState(false);
    }
  };

  closeDrawerOnDesktop();
  if (typeof desktopMenuQuery.addEventListener === 'function') {
    desktopMenuQuery.addEventListener('change', closeDrawerOnDesktop);
  } else {
    desktopMenuQuery.addListener(closeDrawerOnDesktop);
  }

  document.addEventListener('click', (event) => {
    if (!document.body.classList.contains('menu-open')) return;
    const drawer = qs('#MobileMenu');
    if (!drawer) return;
    if (drawer.contains(event.target) || event.target.closest('[data-menu-toggle]')) return;
    setDrawerState(false);
  });

  document.addEventListener('keydown', (event) => {
    if (isProductLightboxOpen?.()) {
      if (event.key === 'Escape') closeProductLightbox();
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        productLightboxMove(-1);
      }
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        productLightboxMove(1);
      }
    }

    if (event.key === 'Escape' && document.body.classList.contains('menu-open')) {
      setDrawerState(false);
    }
  });

  qsa('[data-qty]').forEach((button) => {
    button.addEventListener('click', () => {
      const input = qs(button.dataset.qty, button.closest('form') || document);
      if (!input) return;
      const current = Number(input.value || 1);
      const next = button.dataset.qtyAction === 'plus' ? current + 1 : Math.max(1, current - 1);
      input.value = next;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  const productMediaLabel = (button) => button.getAttribute('aria-label')?.replace(/^View\s+/i, '') || 'Product media';
  const setProductGalleryMedia = (gallery, button, shouldScroll = true) => {
    if (!gallery || !button) return;
    const mediaId = button.dataset.mediaTarget;
    qsa('[data-product-media]', gallery).forEach((item) => item.classList.toggle('is-active', item.dataset.productMedia === mediaId));
    qsa('[data-media-target]', gallery).forEach((thumb) => {
      const active = thumb === button;
      thumb.classList.toggle('is-active', active);
      thumb.setAttribute('aria-pressed', String(active));
      if (active) {
        thumb.setAttribute('aria-current', 'true');
      } else {
        thumb.removeAttribute('aria-current');
      }
    });
    const status = qs('[data-gallery-status]', gallery);
    if (status) status.textContent = `${productMediaLabel(button)} selected`;
    if (shouldScroll) button.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
  };
  const moveProductGalleryMedia = (gallery, direction) => {
    const buttons = qsa('[data-media-target]', gallery);
    if (buttons.length < 2) return;
    const activeIndex = Math.max(0, buttons.findIndex((button) => button.classList.contains('is-active')));
    const nextIndex = (activeIndex + direction + buttons.length) % buttons.length;
    setProductGalleryMedia(gallery, buttons[nextIndex], true);
  };

  qsa('[data-media-target]').forEach((button) => {
    button.addEventListener('click', () => {
      const gallery = button.closest('[data-product-gallery]');
      setProductGalleryMedia(gallery, button);
    });
  });

  qsa('[data-product-gallery]').forEach((gallery) => {
    const activeThumb = qs('[data-media-target].is-active', gallery);
    const status = qs('[data-gallery-status]', gallery);
    if (activeThumb && status) {
      status.textContent = `${productMediaLabel(activeThumb)} selected`;
    }
  });

  qsa('[data-gallery-scroll]').forEach((button) => {
    const thumbs = button.closest('[data-product-gallery]')?.querySelector('[data-gallery-thumbs]');
    const previous = button.dataset.galleryScroll === 'prev';
    const updatePreviousState = () => {
      if (!previous || !thumbs) return;
      button.classList.toggle('is-visible', thumbs.scrollTop > 4);
    };
    updatePreviousState();
    thumbs?.addEventListener('scroll', updatePreviousState, { passive: true });
    button.addEventListener('click', () => {
      if (!thumbs) return;
      const distance = thumbs.querySelector('.product-gallery__thumb')?.getBoundingClientRect().height || 88;
      thumbs.scrollBy({ top: (button.dataset.galleryScroll === 'next' ? 1 : -1) * (distance + 10) * 3, behavior: 'smooth' });
      window.setTimeout(updatePreviousState, 350);
    });
  });

  const productLightboxQuery = window.matchMedia('(max-width: 990px)');
  const productLightbox = document.createElement('div');
  productLightbox.className = 'product-lightbox';
  productLightbox.setAttribute('role', 'dialog');
  productLightbox.setAttribute('aria-modal', 'true');
  productLightbox.setAttribute('aria-label', 'Product media preview');
  productLightbox.setAttribute('hidden', '');
  productLightbox.innerHTML = `
    <button class="product-lightbox__close" type="button" aria-label="Close product media preview">×</button>
    <button class="product-lightbox__arrow product-lightbox__arrow--prev" type="button" aria-label="Previous product media">‹</button>
    <div class="product-lightbox__media"></div>
    <button class="product-lightbox__arrow product-lightbox__arrow--next" type="button" aria-label="Next product media">›</button>
    <div class="product-lightbox__count" aria-live="polite"></div>
  `;
  document.body.appendChild(productLightbox);

  const productLightboxMedia = qs('.product-lightbox__media', productLightbox);
  const productLightboxClose = qs('.product-lightbox__close', productLightbox);
  const productLightboxPrev = qs('.product-lightbox__arrow--prev', productLightbox);
  const productLightboxNext = qs('.product-lightbox__arrow--next', productLightbox);
  const productLightboxCount = qs('.product-lightbox__count', productLightbox);
  let productLightboxLastFocus = null;
  let productLightboxItems = [];
  let productLightboxIndex = 0;
  let productLightboxTouchStartX = null;

  function isProductLightboxOpen() {
    return !productLightbox.hasAttribute('hidden');
  }

  function closeProductLightbox() {
    if (productLightbox.hasAttribute('hidden')) return;
    productLightbox.setAttribute('hidden', '');
    document.body.classList.remove('product-lightbox-open');
    productLightboxMedia.replaceChildren();
    productLightboxItems = [];
    productLightboxIndex = 0;
    productLightboxLastFocus?.focus?.({ preventScroll: true });
    productLightboxLastFocus = null;
  }

  const renderProductLightboxMedia = () => {
    const activeItem = productLightboxItems[productLightboxIndex];
    const media = activeItem?.querySelector('img, video, iframe, model-viewer');
    if (!media) return;

    const clone = media.cloneNode(true);
    if (clone.tagName === 'VIDEO') {
      clone.setAttribute('controls', '');
      clone.removeAttribute('autoplay');
      clone.muted = false;
      try {
        clone.currentTime = media.currentTime || 0;
      } catch (error) {
        // Some mobile browsers block seeking before cloned video metadata loads.
      }
    }

    productLightboxMedia.replaceChildren(clone);
    productLightboxCount.textContent = `${productLightboxIndex + 1} / ${productLightboxItems.length}`;
    productLightboxPrev.toggleAttribute('hidden', productLightboxItems.length < 2);
    productLightboxNext.toggleAttribute('hidden', productLightboxItems.length < 2);
  };

  function productLightboxMove(direction) {
    if (!isProductLightboxOpen() || productLightboxItems.length < 2) return;
    productLightboxIndex = (productLightboxIndex + direction + productLightboxItems.length) % productLightboxItems.length;
    renderProductLightboxMedia();
  }

  const openProductLightbox = (stage) => {
    if (!productLightboxQuery.matches) return;
    const gallery = stage.closest('[data-product-gallery]');
    const activeMedia = qs('.product-media.is-active', stage);
    if (!gallery || !activeMedia) return;
    productLightboxItems = qsa('[data-product-media]', gallery).filter((item) => qs('img, video, iframe, model-viewer', item));
    productLightboxIndex = Math.max(0, productLightboxItems.indexOf(activeMedia));
    if (!productLightboxItems.length) return;

    productLightboxLastFocus = document.activeElement;
    renderProductLightboxMedia();
    productLightbox.removeAttribute('hidden');
    document.body.classList.add('product-lightbox-open');
    productLightboxClose.focus({ preventScroll: true });
  };

  const productGalleryStages = qsa('.product-gallery__stage');
  productGalleryStages.forEach((stage) => {
    let swipeStartX = null;
    let swipeStartY = null;

    stage.addEventListener('touchstart', (event) => {
      if (!productLightboxQuery.matches || isProductLightboxOpen?.()) return;
      const touch = event.changedTouches[0];
      swipeStartX = touch?.clientX ?? null;
      swipeStartY = touch?.clientY ?? null;
    }, { passive: true });

    stage.addEventListener('touchend', (event) => {
      if (!productLightboxQuery.matches || isProductLightboxOpen?.() || swipeStartX === null || swipeStartY === null) return;
      const touch = event.changedTouches[0];
      const endX = touch?.clientX ?? swipeStartX;
      const endY = touch?.clientY ?? swipeStartY;
      const deltaX = endX - swipeStartX;
      const deltaY = endY - swipeStartY;
      swipeStartX = null;
      swipeStartY = null;
      if (Math.abs(deltaX) < 48 || Math.abs(deltaX) < Math.abs(deltaY) * 1.25) return;
      const gallery = stage.closest('[data-product-gallery]');
      moveProductGalleryMedia(gallery, deltaX > 0 ? -1 : 1);
      stage.dataset.swipeHandled = 'true';
      window.setTimeout(() => {
        delete stage.dataset.swipeHandled;
      }, 350);
    }, { passive: true });
  });
  const syncProductLightboxStageState = () => {
    productGalleryStages.forEach((stage) => {
      if (productLightboxQuery.matches) {
        stage.setAttribute('tabindex', '0');
        stage.setAttribute('role', 'button');
        stage.setAttribute('aria-label', 'Open selected product media');
      } else {
        stage.removeAttribute('tabindex');
        stage.removeAttribute('role');
        stage.removeAttribute('aria-label');
      }
    });
  };

  productGalleryStages.forEach((stage) => {

    stage.addEventListener('click', (event) => {
      if (stage.dataset.swipeHandled === 'true') return;
      if (event.target.closest('.stat-chip')) return;
      openProductLightbox(stage);
    });

    stage.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      openProductLightbox(stage);
    });
  });

  productLightboxClose.addEventListener('click', closeProductLightbox);
  productLightboxPrev.addEventListener('click', () => productLightboxMove(-1));
  productLightboxNext.addEventListener('click', () => productLightboxMove(1));
  productLightbox.addEventListener('click', (event) => {
    if (event.target === productLightbox) closeProductLightbox();
  });
  const productLightboxControlSelector = '.product-lightbox__close, .product-lightbox__arrow';
  productLightbox.addEventListener('touchstart', (event) => {
    if (!isProductLightboxOpen() || event.target.closest(productLightboxControlSelector)) return;
    productLightboxTouchStartX = event.changedTouches[0]?.clientX ?? null;
  }, { passive: true, capture: true });
  productLightbox.addEventListener('touchend', (event) => {
    if (!isProductLightboxOpen() || event.target.closest(productLightboxControlSelector) || productLightboxTouchStartX === null) return;
    const endX = event.changedTouches[0]?.clientX ?? productLightboxTouchStartX;
    const deltaX = endX - productLightboxTouchStartX;
    productLightboxTouchStartX = null;
    if (Math.abs(deltaX) < 48) return;
    productLightboxMove(deltaX > 0 ? -1 : 1);
  }, { passive: true, capture: true });
  syncProductLightboxStageState();
  if (typeof productLightboxQuery.addEventListener === 'function') {
    productLightboxQuery.addEventListener('change', syncProductLightboxStageState);
  } else {
    productLightboxQuery.addListener(syncProductLightboxStageState);
  }

  qsa('[data-tabs]').forEach((tabs) => {
    const buttons = qsa('[data-tab-button]', tabs);
    const panels = qsa('[data-tab-panel]', tabs);
    const activateTab = (button, shouldFocus = false) => {
      const target = button.dataset.tabButton;
      buttons.forEach((item) => {
        const active = item === button;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-selected', String(active));
        item.setAttribute('tabindex', active ? '0' : '-1');
      });
      panels.forEach((panel) => {
        const active = panel.dataset.tabPanel === target;
        panel.classList.toggle('is-active', active);
        panel.hidden = !active;
      });
      if (shouldFocus) button.focus();
    };
    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        activateTab(button);
      });
      button.addEventListener('keydown', (event) => {
        const currentIndex = buttons.indexOf(button);
        let nextIndex = currentIndex;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (currentIndex + 1) % buttons.length;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (currentIndex - 1 + buttons.length) % buttons.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = buttons.length - 1;
        if (nextIndex === currentIndex) return;
        event.preventDefault();
        activateTab(buttons[nextIndex], true);
      });
    });
  });

  const footerAccordions = qsa('.footer-accordion');
  const syncFooterAccordions = () => {
    const mobileFooter = footerMediaQuery.matches;
    footerAccordions.forEach((accordion) => {
      accordion.open = !mobileFooter;
    });
  };
  const footerMediaQuery = window.matchMedia('(max-width: 860px)');
  if (footerAccordions.length) {
    syncFooterAccordions();
    if (typeof footerMediaQuery.addEventListener === 'function') {
      footerMediaQuery.addEventListener('change', syncFooterAccordions);
    } else {
      footerMediaQuery.addListener(syncFooterAccordions);
    }
  }

  qsa('[data-faq-list]').forEach((list) => {
    const root = list.closest('[data-faq-root]') || list;
    const items = qsa('[data-faq-item]', list);
    if (!items.length) return;

    const categoryButtons = qsa('[data-faq-category-toggle]', list);
    const setItems = (targetItems, open) => {
      targetItems.forEach((item) => {
        item.open = open;
      });
    };
    const itemsForCategory = (category) => items.filter((item) => item.dataset.faqCategory === category);
    const syncCategoryButton = (button) => {
      const categoryItems = itemsForCategory(button.dataset.faqCategoryToggle);
      const allOpen = categoryItems.length > 0 && categoryItems.every((item) => item.open);
      const label = qs('[data-faq-category-label]', button);
      button.setAttribute('aria-expanded', String(allOpen));
      if (label) label.textContent = allOpen ? 'Collapse section' : 'Expand section';
    };
    const syncButtons = () => {
      categoryButtons.forEach(syncCategoryButton);
    };

    categoryButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const categoryItems = itemsForCategory(button.dataset.faqCategoryToggle);
        const shouldOpen = !categoryItems.every((item) => item.open);
        setItems(categoryItems, shouldOpen);
        syncButtons();
      });
    });

    qsa('[data-faq-action]', root).forEach((button) => {
      button.addEventListener('click', () => {
        setItems(items, button.dataset.faqAction === 'expand-all');
        syncButtons();
      });
    });

    items.forEach((item) => item.addEventListener('toggle', syncButtons));
    syncButtons();
  });

  qsa('[data-slider]').forEach((slider) => {
    const track = qs('[data-slider-track]', slider);
    const prev = qs('[data-slider-prev]', slider);
    const next = qs('[data-slider-next]', slider);
    if (!track) return;
    const step = () => Math.max(track.clientWidth * 0.85, 280);
    prev?.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
    next?.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
  });

  // Non-marquee review rails can still auto-advance card-by-card.
  qsa('.athletes-hscroll, .athletes-review-grid').forEach((track) => {
    track.classList.add('is-interactive');
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    let inView = true;
    const step = () => Math.max(track.clientWidth * 0.8, 280);
    const move = () => {
      const maxScroll = track.scrollWidth - track.clientWidth;
      if (maxScroll <= 8) return;
      if (track.scrollLeft >= maxScroll - 8) {
        track.scrollTo({ left: 0, behavior: 'smooth' });
        return;
      }
      track.scrollBy({ left: step(), behavior: 'smooth' });
    };

    window.setInterval(() => {
      if (!document.hidden && inView) move();
    }, 4000);

    if ('IntersectionObserver' in window) {
      new IntersectionObserver((entries) => {
        inView = entries[0]?.isIntersecting ?? true;
      }, { rootMargin: '160px 0px' }).observe(track);
    }
  });

  const revealTargets = qsa([
    '.hero__copy',
    '.hero__media',
    '.benefit-card',
    '.step-card',
    '.feature-media',
    '.feature-content',
    '.feature-list li',
    '.review-card',
    '.product-gallery',
    '.product-info',
    '.product-proof-strip__item',
    '.team-supply-card',
    '.product-visual-story',
    '.tabs__panel',
    '.ingredient-card',
    '.athlete-band__grid',
    '.athlete-quote',
    '.athletes-hero',
    '.athletes-hscroll .review-card',
    '.athletes-review-display',
    '.athletes-review-display__header',
    '.review-form-card',
    '.faq-intro',
    '.accordion-item',
    '.faq-support-card',
    '.contact-panel',
    '.form-panel',
    '.contact-fast-card',
    '.directions-video__copy',
    '.directions-video__media'
  ].join(','));

  if (revealTargets.length && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    revealTargets.forEach((item) => item.classList.add('motion-reveal'));
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.18, rootMargin: '0px 0px -8% 0px' });

    revealTargets.forEach((item) => observer.observe(item));
  } else {
    revealTargets.forEach((item) => item.classList.add('is-visible'));
  }

  qsa('[data-copy-link]').forEach((button) => {
    button.addEventListener('click', async () => {
      try {
        await navigator.clipboard.writeText(button.dataset.copyLink || window.location.href);
        button.classList.add('is-copied');
        setTimeout(() => button.classList.remove('is-copied'), 1500);
      } catch (error) {
        window.prompt('Copy this link', button.dataset.copyLink || window.location.href);
      }
    });
  });
})();
